import React from "react";

export default function Footer() {
  return (
    <footer>
      This project was coded by{" "}
      <a href="https://github.com/Ndambaza" target="_blank" rel="noreferrer">
        Natalie Dambaza
      </a>
      , is open-sourced on{" "}
      <a
        href="https://github.com/Ndambaza/dictionary-project"
        target="_blank"
        rel="noreferrer"
      >
        Github
      </a>
      and website hosted on{" "}
      <a
        href="https://jovial-alpaca-03b119.netlify.app//"
        target="_blank"
        rel="noreferrer"
      >
        Netlify
      </a>
    </footer>
  );
}
